import React from 'react';
import CountdownOverlay from './CountdownOverlay';
import SlimeOverlay from './SlimeOverlay';
import { useMediaQuery } from './useMediaQuery';
import { useSeason } from './useSeason';

/**
 * Efectos que un clic dispara sobre la página entera. Sin temporada no monta nada.
 * Con movimiento reducido la baba no arranca; la cuenta regresiva sí abre, porque el
 * auditor la pidió con un clic y es información (E07-F01, R10 / P7).
 */
const SeasonalOverlays: React.FC = () => {
  const season = useSeason();
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  if (!season) return null;
  return (
    <>
      <SlimeOverlay disabled={reducedMotion} />
      <CountdownOverlay />
    </>
  );
};

export default SeasonalOverlays;
